import { render, staticRenderFns } from "./desk.vue?vue&type=template&id=94306a8a&"
import script from "./desk.vue?vue&type=script&setup=true&lang=js&"
export * from "./desk.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports